import {ShippingInfoModel} from '../ShippingInfo.model';
import {PriceSummaryModel} from '../PriceSummary.model';
import {ViolationModel} from '../Violation.model';
import {AdditionalFeeModel} from './AdditionalFee.model';
import {MinimumOrderAmountModel} from '../MinimumOrderAmount.model';
import {EstimateTotalsResponse} from '@wix/auto_sdk_ecom_current-cart';
import {CouponDiscountModel} from '../CouponDiscount.model';
import {toAppliedCouponCartV1} from '../../utils/coupon';
import {ModelContext} from '../../../types/app.types';
import {SPECS} from '../../specs';
import {CouponModel} from '../Cart/Coupon.model';

export class CartSummaryModel {
  public additionalFees: AdditionalFeeModel[];

  public priceSummary: PriceSummaryModel;
  public shippingInfo: ShippingInfoModel;
  public payNow: PriceSummaryModel;
  public payLater: PriceSummaryModel;
  public payAfterFreeTrial: PriceSummaryModel;
  public violations: ViolationModel[];
  public minimumOrderAmount: MinimumOrderAmountModel;
  public estimatedAmountToPay: number;
  /**
   * @deprecated
   */
  public appliedCoupon: CouponModel;
  public couponDiscount: CouponDiscountModel;
  public paymentCurrencyCode: string;

  constructor(params: CartSummaryModel) {
    this.priceSummary = params.priceSummary;
    this.shippingInfo = params.shippingInfo;
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.payAfterFreeTrial = params.payAfterFreeTrial;
    this.additionalFees = params.additionalFees;
    this.violations = params.violations;
    this.minimumOrderAmount = params.minimumOrderAmount;
    this.estimatedAmountToPay = params.estimatedAmountToPay;
    this.appliedCoupon = params.appliedCoupon;
    this.couponDiscount = params.couponDiscount;
    this.paymentCurrencyCode = params.paymentCurrencyCode;
  }

  public static fromCartV1(estimatedTotals: EstimateTotalsResponse, modelContext: ModelContext): CartSummaryModel {
    return new CartSummaryModel({
      additionalFees: (estimatedTotals?.additionalFees ?? []).map((fee) =>
        AdditionalFeeModel.fromCartV1(fee, modelContext)
      ),
      estimatedAmountToPay: Number(
        modelContext.shouldPayWithConvertedCurrency
          ? estimatedTotals.priceSummary.total.convertedAmount
          : estimatedTotals.priceSummary.total.amount
      ),
      minimumOrderAmount: MinimumOrderAmountModel.fromSDK(
        estimatedTotals.calculationErrors.orderValidationErrors,
        modelContext
      ),
      payLater: PriceSummaryModel.fromSDK(estimatedTotals.payLater, modelContext),
      payNow: PriceSummaryModel.fromSDK(estimatedTotals.payNow, modelContext),
      payAfterFreeTrial: modelContext.viewerContext.isExperimentEnabled(SPECS.SupportSubscriptionsInPurchaseFlow)
        ? PriceSummaryModel.fromSDK(estimatedTotals.payAfterFreeTrial, modelContext)
        : undefined,
      priceSummary: PriceSummaryModel.fromSDK(estimatedTotals.priceSummary, modelContext),
      shippingInfo: estimatedTotals.shippingInfo ? ShippingInfoModel.fromSDK(estimatedTotals.shippingInfo) : undefined,
      violations: (estimatedTotals?.violations ?? []).map(ViolationModel.fromSDK),
      appliedCoupon: toAppliedCouponCartV1(estimatedTotals.appliedDiscounts, modelContext),
      couponDiscount: CouponDiscountModel.fromCartV1(estimatedTotals.appliedDiscounts, modelContext),
      paymentCurrencyCode: modelContext.paymentCurrencyCode,
    });
  }
}
